/**
 * Defines the type of input used to make a search request.
 */
export enum SearchInputType {
  SEARCH_INPUT_TYPE_UNKNOWN = 'SEARCH_INPUT_TYPE_UNKNOWN',
  /**
   * The search was initiated using text input, this is default/traditional input type.
   */
  SEARCH_INPUT_TYPE_TEXT = 'SEARCH_INPUT_TYPE_TEXT',
  /**
   * The search was initiated using an image.
   */
  SEARCH_INPUT_TYPE_IMAGE = 'SEARCH_INPUT_TYPE_IMAGE',
  /**
   * The search was initiated using a combination of text and image.
   */
  SEARCH_INPUT_TYPE_TEXT_AND_IMAGE = 'SEARCH_INPUT_TYPE_TEXT_AND_IMAGE',
  /**
   * The search was initiated using natural language input (e.g., LLM-powered search).
   */
  SEARCH_INPUT_TYPE_NATURAL_LANGUAGE = 'SEARCH_INPUT_TYPE_NATURAL_LANGUAGE',
}
